import { getAddress } from '@ethersproject/address'
import { BigNumber } from '@ethersproject/bignumber'
import { MinusIcon, PlusIcon } from '@heroicons/react/solid'
import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { ChainId, MASTERCHEF_ADDRESS, MASTERCHEF_V2_ADDRESS, MINICHEF_ADDRESS, Token } from 'sdk'
import AssetInput from 'app/components/AssetInput'
// import Button from 'app/components/Button'
import { HeadlessUiModal } from 'app/components/Modal'
import Switch from 'app/components/Switch'
import Typography from 'app/components/Typography'
import Web3Connect from 'app/components/Web3Connect'
import { OLD_FARMS } from 'app/config/farms'
import { useFarmListItemDetailsModal } from 'app/features/onsen/FarmListItemDetails'
import { setOnsenModalOpen } from 'app/features/onsen/onsenSlice'
import { classNames, tryParseAmount } from 'app/functions'
import { ApprovalState, useApproveCallback } from 'app/hooks/useApproveCallback'
import { useActiveWeb3React } from 'app/services/web3'
import { useAppDispatch } from 'app/state/hooks'
import { useTransactionAdder } from 'app/state/transactions/hooks'
import { useCurrencyBalance } from 'app/state/wallet/hooks'
import React, { useState } from 'react'
import {
  Box,
  Text,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useDisclosure,
  useColorMode,
  Image,
  Heading,
  Input,
  ModalBody,
} from '@chakra-ui/react'

import { Chef, PairType } from './enum'
import { useUserInfo } from './hooks'
import useMasterChef from './useMasterChef'

const APPROVAL_ADDRESSES = {
  [Chef.MASTERCHEF]: { [ChainId.AVALANCHE]: MASTERCHEF_ADDRESS[ChainId.AVALANCHE] },
  [Chef.MASTERCHEF_V2]: { [ChainId.AVALANCHE]: MASTERCHEF_V2_ADDRESS[ChainId.AVALANCHE] },
  [Chef.MINICHEF]: {
    [ChainId.MATIC]: MINICHEF_ADDRESS[ChainId.MATIC],
    [ChainId.XDAI]: MINICHEF_ADDRESS[ChainId.XDAI],
    [ChainId.HARMONY]: MINICHEF_ADDRESS[ChainId.HARMONY],
    [ChainId.ARBITRUM]: MINICHEF_ADDRESS[ChainId.ARBITRUM],
    [ChainId.CELO]: MINICHEF_ADDRESS[ChainId.CELO],
    [ChainId.MOONRIVER]: MINICHEF_ADDRESS[ChainId.MOONRIVER],
    [ChainId.FUSE]: MINICHEF_ADDRESS[ChainId.FUSE],
    [ChainId.FANTOM]: MINICHEF_ADDRESS[ChainId.FANTOM],
  },
  [Chef.OLD_FARMS]: {
    [ChainId.CELO]: OLD_FARMS[ChainId.CELO],
  },
}

// @ts-ignore TYPE NEEDS FIXING
const ManageBar = ({ farm }) => {
  const dispatch = useAppDispatch()
  const { account, chainId } = useActiveWeb3React()
  const { setContent } = useFarmListItemDetailsModal()
  const [toggle, setToggle] = useState(true)
  const [depositValue, setDepositValue] = useState<string>()
  const [withdrawValue, setWithdrawValue] = useState<string>()
  const { deposit, withdraw } = useMasterChef(farm.chef)
  const addTransaction = useTransactionAdder()
  const liquidityToken = new Token(
    // @ts-ignore TYPE NEEDS FIXING
    chainId || 1,
    getAddress(farm.pair.id),
    farm.pair.type === PairType.KASHI ? Number(farm.pair.asset.decimals) : 18,
    farm.pair.type === PairType.KASHI ? 'KMP' : 'OVXLP'
  )
  const balance = useCurrencyBalance(account ?? undefined, liquidityToken)
  const stakedAmount = useUserInfo(farm, liquidityToken)
  const parsedDepositValue = tryParseAmount(depositValue, liquidityToken)
  const parsedWithdrawValue = tryParseAmount(withdrawValue, liquidityToken)
  // @ts-ignore TYPE NEEDS FIXING
  const [approvalState, approve] = useApproveCallback(parsedDepositValue, APPROVAL_ADDRESSES[farm.chef][chainId])

  const depositError = !parsedDepositValue
    ? 'Enter an amount'
    : balance?.lessThan(parsedDepositValue)
    ? 'Insufficient balance'
    : undefined
  const isDepositValid = !depositError
  const withdrawError = !parsedWithdrawValue
    ? 'Enter an amount'
    : // @ts-ignore TYPE NEEDS FIXING
    stakedAmount?.lessThan(parsedWithdrawValue)
    ? 'Insufficient balance'
    : undefined
  const isWithdrawValid = !withdrawError

  const [isActive, setActive] = useState(false)
  const toggleClass = () => {
    setActive(!isActive)
  }

  return (
    <>
      <Box className="last_teb_panal">
        <Box className="liq_swich_txt">
          <Box className="add_liqy_txt">
            <Heading as="h5">{toggle ? i18n._(t`Stake liquidity`) : i18n._(t`Unstake liquidity`)}</Heading>
          </Box>
          <Box className="swich_setting">
            <Box className="nw_swich_v2">
              <Box className="swtch_main swtch_main_liq_p_up">
                <Box className="switch_box switch_boxv2">
                  <input type="checkbox" id="switchOne" checked={toggle} onChange={() => setToggle(!toggle)} />
                  <label htmlFor="switchOne">
                    <span>
                      <Image src="/img/mns_icon.svg" className="mns_icon" alt="" />
                      <Image src="/img/plus_icon_p_up.svg" className="pls_icon" alt="" />
                    </span>
                  </label>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="use_one_p">
          <Text>Use one of the buttons to set a percentage or enter a value manually using the input field</Text>
        </Box>
        <Box className="nw_redio_btn">
          <Box className="radio_btn_bx">
            {['25', '50', '75', '100'].map((multiplier, i) => (
              <Button
                variant="outlined"
                size="xs"
                color={toggle ? 'blue' : 'pink'}
                key={i}
                onClick={() => {
                  toggle
                    ? balance
                      ? // @ts-ignore TYPE NEEDS FIXING
                        setDepositValue(balance.multiply(multiplier).divide(100).toExact())
                      : undefined
                    : stakedAmount
                    ? // @ts-ignore TYPE NEEDS FIXING
                      setWithdrawValue(stakedAmount.multiply(multiplier).divide(100).toExact())
                    : undefined
                }}
                className={classNames(
                  'text-md border border-opacity-50',
                  toggle ? 'focus:ring-blue border-blue' : 'focus:ring-pink border-pink'
                )}
              >
                {multiplier === '100' ? 'MAX' : multiplier + '%'}
              </Button>
            ))}
            {/* <Button>25%</Button>
          <Button>50%</Button>
          <Button>75%</Button>
          <Button>MAX</Button> */}
          </Box>
        </Box>
        <Box className="amont_slp_mx">
          <AssetInput
            currencyLogo={false}
            currency={liquidityToken}
            value={toggle ? depositValue : withdrawValue}
            onChange={toggle ? setDepositValue : setWithdrawValue}
            balance={toggle ? undefined : stakedAmount}
            showMax={false}
          />
          <Box className="enter_btn">
            {toggle ? (
              !account ? (
                <Web3Connect size="lg" color="blue" fullWidth />
              ) : isDepositValid &&
                (approvalState === ApprovalState.NOT_APPROVED || approvalState === ApprovalState.PENDING) ? (
                <Button
                  fullWidth
                  loading={approvalState === ApprovalState.PENDING}
                  // className="Button"
                  // color="blue"
                  onClick={approve}
                  disabled={approvalState !== ApprovalState.NOT_APPROVED}
                >
                  {i18n._(t`Approve`)}
                </Button>
              ) : (
                <Button
                  fullWidth
                  // className="Button"
                  // color={!isDepositValid && !!parsedDepositValue ? 'red' : 'blue'}
                  onClick={async () => {
                    try {
                      // KMP decimals depend on asset, SLP is always 18
                      // @ts-ignore TYPE NEEDS FIXING
                      const tx = await deposit(farm.id, BigNumber.from(parsedDepositValue?.quotient.toString()))
                      if (tx?.hash) {
                        setContent(
                          <HeadlessUiModal.SubmittedModalContent
                            txHash={tx?.hash}
                            header={i18n._(t`Back`)}
                            subheader={i18n._(t`Success! Transaction successfully submitted`)}
                            onDismiss={() => setContent(undefined)}
                            //                        onDismiss={() => dispatch(setOnsenModalOpen(false))}  // old versxion fail because using REDUX.
                          />
                        )
                        addTransaction(tx, {
                          summary: `Deposit ${farm.pair.token0.name}/${farm.pair.token1.name}`,
                        })
                      }
                    } catch (error) {
                      console.error(error)
                    }
                  }}
                  disabled={!isDepositValid}
                >
                  {depositError || i18n._(t`Confirm Deposit`)}
                </Button>
              )
            ) : !account ? (
              <Web3Connect color="blue" className="w-full" />
            ) : (
              <Button
                fullWidth
                // className="Button"
                // color={!isWithdrawValid && !!parsedWithdrawValue ? 'red' : 'blue'}
                onClick={async () => {
                  try {
                    // KMP decimals depend on asset, SLP is always 18
                    // @ts-ignore TYPE NEEDS FIXING
                    const tx = await withdraw(farm.id, BigNumber.from(parsedWithdrawValue?.quotient.toString()))
                    if (tx?.hash) {
                      setContent(
                        <HeadlessUiModal.SubmittedModalContent
                          txHash={tx?.hash}
                          header={i18n._(t`Back`)}
                          subheader={i18n._(t`Success! Transaction successfully submitted`)}
                          onDismiss={() => setContent(undefined)}
                        />
                      )
                      addTransaction(tx, {
                        summary: `Withdraw ${farm.pair.token0.name}/${farm.pair.token1.name}`,
                      })
                    }
                  } catch (error) {
                    console.error(error)
                  }
                }}
                disabled={!isWithdrawValid}
              >
                {withdrawError || i18n._(t`Confirm Withdraw`)}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default ManageBar